import React from 'react';
import styled from 'styled-components';

export const StyledLanguageButton = styled.button`
  width: 40px;
  height: 40px;
  text-align: center;
  color: ${({ theme }) =>
    theme.whiteLanguageMenuColor ? theme.colorWhite : theme.colorPrimary};
  font-size: 20px;
  font-weight: 300;
  text-decoration: none;
  text-transform: uppercase;
  line-height: 1;
  background-color: transparent;
  padding: 3px 0;
  border-radius: ${props => props.theme.borderRadius}px;
  outline-offset: 3px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  margin: 0 -1px;
  border: 1px solid transparent;
  &.selected {
    border-color: ${({ theme }) =>
      theme.whiteLanguageMenuColor ? theme.colorWhite : theme.colorPrimary};
  }
  &:hover {
    color: ${({ theme }) =>
      theme.whiteLanguageMenuColor
        ? theme.colorWhite
        : theme.colorPrimaryHover};
    background-color: ${({ theme }) =>
      theme.whiteLanguageMenuColor ? theme.colorPrimaryActive : 'transparent'};
  }
  &:focus-visible {
    outline: 2px solid ${props => props.theme.focusOutlineNegativeColor} !important;
    outline-offset: 1px;
    transition: all 0.3s, visibility 0.3s;
  }
`;

export interface ILanguageButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export function LanguageButton(props: ILanguageButtonProps) {
  return <StyledLanguageButton {...props} />;
}
